import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import BackButton from 'components/BackButton';
import ListTick from 'components/Icons/tick-list';
import { INIT_UI_LANGUAGE } from 'constants/languages';
import {
  StyledCenteredBlock,
  StyledLanguageButton,
  StyledLanguageButtonsGroup,
  StyledPage,
  StyledPageContent,
  StyledPageLayout,
  StyledPageTitle,
} from './StyledComponents';

const LanguagesPage = React.memo(props => {
  const { languages, changeUILanguage, history, i18n } = props;

  const handleEnter = useCallback(
    lang => {
      changeUILanguage(lang.name);
    },
    [changeUILanguage],
  );

  return (
    <StyledPage>
      <BackButton onEnter={history.goBack} />
      <StyledPageLayout>
        <StyledPageTitle>{i18n.t('profile.languages')}</StyledPageTitle>
        <StyledPageContent>
          <StyledCenteredBlock>
            <StyledLanguageButtonsGroup defaultSection>
              {languages.map(lang => (
                <StyledLanguageButton
                  onEnter={handleEnter}
                  key={lang.name}
                  payload={lang}
                  focusOnMouseEnter
                  selected={INIT_UI_LANGUAGE === lang.name}
                >
                  {i18n.t(lang.titleKey)}
                  <ListTick />
                </StyledLanguageButton>
              ))}
            </StyledLanguageButtonsGroup>
          </StyledCenteredBlock>
        </StyledPageContent>
      </StyledPageLayout>
    </StyledPage>
  );
});

LanguagesPage.propTypes = {
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      title: PropTypes.string,
    }),
  ).isRequired,
  changeUILanguage: PropTypes.func.isRequired,
};

export default LanguagesPage;
